import { useEffect, useState } from 'react';
import { getCmsDataInfo } from 'src/api/pages/paddleCmsData';
import { IDocNav } from './../../type';

const useDocNav = () => {
    const [navData, setNavData] = useState<IDocNav>({
        title: '',
        desc: '',
        list: []
    });

    useEffect(() => {
        (async () => {
            const res = await getCmsDataInfo({ requestUrl: '/paddleApiNav' }).catch(err => {
                // ignore
            });

            if (res) {
                const data = res.body.result?.pageData || {};
                data.paddleApiNav && setNavData(data.paddleApiNav);
            }
        })();
    }, []);

    return {
        navData
    };
};

export default useDocNav;
